import { render, staticRenderFns } from "./WameedBtn.vue?vue&type=template&id=188bdf97&"
import script from "./WameedBtn.vue?vue&type=script&lang=js&"
export * from "./WameedBtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports